import React from 'react';
import { useApiQuery } from '../hooks/useApiQuery';
import { getMealReport } from '../services/api';

const MealReportPanel = ({ eventId }) => {
  const { data: report = [], isLoading } = useApiQuery(
    ['meal-report', eventId],
    () => getMealReport(eventId).then(r => r.data),
    { enabled: Boolean(eventId) }
  );

  if (isLoading) return <div className="p-4 text-sm text-gray-400">Loading...</div>;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {report.map(r => (
          <div key={r.mealTypeId} className="bg-white rounded-xl border border-gray-100 p-5">
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-semibold text-gray-900">{r.mealName}</h3>
              <span className="text-sm text-gray-500">₹{r.price}</span>
            </div>
            <div className="grid grid-cols-3 gap-3 text-center">
              <div>
                <p className="text-xs text-gray-500">Paid</p>
                <p className="text-lg font-bold text-blue-600">{r.paidCount}</p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Redeemed</p>
                <p className="text-lg font-bold text-green-600">{r.redeemedCount}</p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Pending</p>
                <p className="text-lg font-bold text-amber-600">{r.pendingCount}</p>
              </div>
            </div>
            <div className="mt-3 pt-3 border-t text-sm text-gray-600 flex justify-between">
              <span>Collected</span>
              <span className="font-semibold text-gray-900">₹{r.collectedAmount}</span>
            </div>
          </div>
        ))}
        {report.length === 0 && (
          <div className="md:col-span-2 text-center text-sm text-gray-400 py-12">
            No meals configured for this event.
          </div>
        )}
      </div>
    </div>
  );
};

export default MealReportPanel;